import { useEffect } from 'react';

// Provided by Datawrapper: https://developer.datawrapper.de/docs/responsive-iframe
const useDatawrapperResize = () => {
  useEffect(() => {
    const resizeIframes = (event: MessageEvent) => {
      if (typeof event.data['datawrapper-height'] !== 'undefined') {
        const iframes = document.querySelectorAll('iframe');
        for (const chartId in event.data['datawrapper-height']) {
          iframes.forEach((iframe) => {
            if (iframe.contentWindow === event.source) {
              iframe.style.height = event.data['datawrapper-height'][chartId] + 'px';
            }
          });
        }
      }
    };

    window.addEventListener('message', resizeIframes);

    return () => {
      window.removeEventListener('message', resizeIframes);
    };
  }, []);
};

export default useDatawrapperResize;
